export * as queries from './queries'
export * as mutations from './mutations'
